import { render } from "./SuccessMessage.vue?vue&type=template&id=4e71ad02"
import script from "./SuccessMessage.vue?vue&type=script&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&lang=js"

import "./SuccessMessage.vue?vue&type=style&index=0&id=4e71ad02&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__